export function canContributorOpenDrilldown(contributor) {
  return Boolean(contributor?.id && !contributor.notHeld)
}
